import React, { Component } from "react";
import { Modal, Grid, Icon, Button } from "semantic-ui-react";

export default class ContactsCustomerInfo extends Component {
  render() {
    return (
      <Modal open={this.props.isOpened} size={"small"}>
        <Modal.Header style={{ backgroundColor: "#f3f3f3" }}>
          <div
            style={{
              justifyContent: "space-between",
              display: "flex",
            }}
          >
            Información del contacto
            <Button
              circular
              size="mini"
              basic
              icon="close"
              // floated="right"
              onClick={this.props.onClose}
            />
          </div>
        </Modal.Header>
        <Modal.Content>
          <Grid
            columns={2}
            divided
            textAlign="center"
            style={{ fontSize: "16px" }}
          >
            <Grid.Row>
              <Grid.Column>
                <Grid.Row>
                  <Icon name="mail"></Icon>{" "}
                  <span style={{ fontWeight: "bold" }}>Email</span>
                </Grid.Row>
                <Grid.Row>{this.props.data.email}</Grid.Row>
              </Grid.Column>
              <Grid.Column>
                <Grid.Row>
                  <Icon name="phone"></Icon>{" "}
                  <span style={{ fontWeight: "bold" }}>
                    Teléfono (WhatsApp)
                  </span>
                </Grid.Row>
                <Grid.Row>
                  {this.props.data.whatsapp_telefono || "N/D"}
                </Grid.Row>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Grid.Row>
                  <Icon name="user"></Icon>{" "}
                  <span style={{ fontWeight: "bold" }}>
                    Puesto del contacto
                  </span>
                </Grid.Row>
                <Grid.Row>{this.props.data.puesto_contacto}</Grid.Row>
              </Grid.Column>
              <Grid.Column>
                <Grid.Row>
                  <Icon name="calendar"></Icon>{" "}
                  <span style={{ fontWeight: "bold" }}>Fecha nacimiento</span>
                </Grid.Row>
                <Grid.Row>{this.props.data.fecha_nacimiento || "N/D"}</Grid.Row>
              </Grid.Column>
            </Grid.Row>
            {this.props.data.contactable && (
              <Grid.Row>
                <Grid.Column>
                  <Grid.Row>
                    <Icon name="user"></Icon>{" "}
                    <span style={{ fontWeight: "bold" }}>Cliente</span>
                  </Grid.Row>
                  <Grid.Row>{this.props.data.contactable.nombre}</Grid.Row>
                </Grid.Column>
              </Grid.Row>
            )}
          </Grid>
        </Modal.Content>
      </Modal>
    );
  }
}
